export default {
  getUserInfo: (state) => state.userInfo,
  getOriganization: (state) => state.origanization,
  getHeaderInfo: (state) => state.headerInfo,
  innerHeight: (state) => state.globalData.height || 0, // 视窗高度
};
